<template>
	<div class="popup-content" style="width: 380px! important;">
		<table class="popup-table"  v-if="this.tag == 'suspect' || this.tag == 'task' || this.tag == 'alt_address'">
            <tbody>
			<!-- <tr class="even">
				<th>Address ID</th>
				<td>{{this.tableData.AddressId || 'No Data'}}</td>
			</tr> -->
			<tr class="even">
				<th>Staff ID</th>
				<td>{{this.tableData.StaffId || 'No Data'}}</td>
			</tr>
			<tr class="odd">
				<th>Staff Name</th>
				<td>{{this.tableData.StaffName || 'No Data'}}</td>
			</tr>
			<tr class="even">
				<th>DUID</th>
				<td>{{this.tableData.DUID || 'No Data'}}</td>
			</tr>
			<tr class="odd">
				<th>SPID</th>
				<td>{{this.tableData.SPID || 'No Data'}}</td>
			</tr>
			<tr class="even">
				<th>Task UUID</th>
				<td>{{this.tableData.TaskUUID || 'No Data'}}</td>
			</tr>
			<tr class="even">
				<th>Task Type</th>
				<td>{{this.tableData.TaskType || 'No Data'}}</td>
			</tr>
			<tr class="odd" v-if="this.tableData.showTaskLabel || this.tableData.showTaskLabel === undefined">
          <th> Task Label</th>
          <td>{{this.tableData.TaskLabel || 'No Data'}}</td>
      </tr>
      <tr class="even" v-if="this.tableData.showDispositionCode || this.tableData.showDispositionCode === undefined">
          <th> Disposition Code</th>
          <td>{{this.tableData.DispositionCode || 'No Data'}}</td>
      </tr>
			<tr class="odd" v-if="this.tableData.showDispositionLabel || this.tableData.showDispositionLabel === undefined">
            <th> Disposition Label</th>
            <td>{{this.tableData.DispositionLabel || 'No Data'}}</td>
      </tr>
			<tr class="even" v-if="this.tableData.Comment">
            <th> Comment</th>
            <td v-bind-html="this.tableData.Comment || 'No Data'"></td>
      </tr>
			<tr class="odd">
            <th> Completed Date</th>
            <td>{{this.tableData.DateCOMPLETED || 'No Data'}}
            </td>
      </tr>
			<tr class="even" v-if="this.tableData.PointCompleted && this.tableData.PointCompletedType==='LAPTOP'">
            <th> Closest GPS Point</th>
            <td>
                <a @click="onClosestGPSClicked">
                   <img class="popup-table-img" src="../assets/wgmm_ico_map_gps_laptop_closest.svg"/>
                </a>
            </td>
        </tr>
        <tr class="even" v-if="this.tableData.PointCompleted && this.tableData.PointCompletedType==='PHONE'">
            <th> Closest GPS Point</th>
            <td>
                <a @click="onClosestGPSClicked">
                   <img class="popup-table-img" src="../assets/wgmm_ico_map_gps_laptop_closest.svg"/>
                </a>
            </td>
        </tr>
				<tr class="even">
            <th> Status</th>
            <td>{{this.tableData.Status || 'No Data'}}</td>
        </tr>
        <tr class="odd">
            <th> Status Basis</th>
            <td>{{this.tableData.StatusBasis || 'No Data'}}</td>
        </tr>
		<tr class="even" v-if="this.tableData.ClusterId && this.tableData.ClusterType==='FIELD'">
            <th> Cluster</th>
            <td>
                <a @click="onClusterClicked">
                   <img class="popup-table-img" src="../assets/wgmm_ico_map_cluster.svg" @click="onClusterClicked"/>
                </a>
            </td>
        </tr>
        <tr class="even" v-if="this.tableData.ClusterId && this.tableData.ClusterType==='STOP'">
            <th> Cluster</th>
            <td>
                <a @click="onClusterClicked">
                   <img class="popup-table-img" src="../assets/wgmm_ico_map_cluster.svg" @click="onClusterClicked"/>
                </a>
            </td>
        </tr>
		<tr class="even" v-if="this.tableData.Distance">
            <th> Distance</th>
            <td>{{this.tableData.Distance * 3.28084 || 'No Data'}} feet(s)</td>
        </tr>
        <!--
					<tr class="even" ng-if="appSettings.ACE.taskPopup.popupRows.showLocatedBuildingName || appSettings.ACE.taskPopup.popupRows.showLocatedBuildingName === undefined">
            <td> Building Name</td>
            <td>{{feature.properties['located BuildingName'] || 'No Data'}} </td>
        </tr>
        <tr class="odd" ng-if="feature.properties['located StreetAddress'] || feature.properties['located PlaceName'] || feature.properties['located AdminAreaCode'] || feature.properties['located PostCode']">
            <td ng-if="appSettings.ACE.taskPopup.popupRowColumnLabels.LocatedAddressLabel">{{appSettings.ACE.taskPopup.popupRowColumnLabels.LocatedAddressLabel}}</td>
            <td ng-if="appSettings.ACE.taskPopup.popupRowColumnLabels.LocatedAddressLabel === undefined">Located Address</td>
            <td>
                {{feature.properties['located StreetAddress'] }} <br> {{feature.properties['located PlaceName'] }}&nbsp;{{feature.properties['located AdminAreaCode'] }}&nbsp;{{feature.properties['located PostCode'] }}
            </td>
        </tr>
        <tr class="odd" ng-if="!feature.properties['located StreetAddress'] && !feature.properties['located PlaceName'] && !feature.properties['located AdminAreaCode'] && !feature.properties['located PostCode']">
            <td ng-if="appSettings.ACE.taskPopup.popupRowColumnLabels.LocatedAddressLabel">{{appSettings.ACE.taskPopup.popupRowColumnLabels.LocatedAddressLabel}}</td>
            <td ng-if="appSettings.ACE.taskPopup.popupRowColumnLabels.LocatedAddressLabel === undefined">Located Address</td>
            <td>
                No Data
            </td>
        </tr>
        <tr class="even" ng-if="feature.properties['geoCoded StreetAddress'] || feature.properties['geoCoded PlaceName'] || feature.properties['geoCoded AdminAreaCode'] || feature.properties['geoCoded PostCode'] && (appSettings.ACE.taskPopup.popupRows.showGeocodedAddress || appSettings.ACE.taskPopup.popupRows.showGeocodedAddress === undefined)">
            <td> Geocoded Address</td>
            <td>
                {{feature.properties['geoCoded StreetAddress'] }} <br>{{feature.properties['geoCoded PlaceName'] }}&nbsp;{{feature.properties['geoCoded AdminAreaCode'] }}&nbsp;{{feature.properties['geoCoded PostCode'] }}
            </td>
        </tr>
        <tr class="even" ng-if="!feature.properties['geoCoded StreetAddress'] && !feature.properties['geoCoded PlaceName'] && !feature.properties['geoCoded AdminAreaCode'] && !feature.properties['geoCoded PostCode'] && (appSettings.ACE.taskPopup.popupRows.showGeocodedAddress || appSettings.ACE.taskPopup.popupRows.showGeocodedAddress === undefined)">
            <td> Geocoded Address</td>
            <td>
                No Data
            </td>
        </tr>
        <tr class="odd" ng-if="appSettings.ACE.taskPopup.popupRows.showGeoMatch || appSettings.ACE.taskPopup.popupRows.showGeoMatch === undefined">
            <td> Geo Match</td>
            <td>{{feature.properties['geoCoded GeoMatchType'] || 'No Data'}}</td>
        </tr>
				 -->
				<tr class="even">
            <th> Region</th>
            <td>{{this.tableData.Region || 'No Data'}}</td>
        </tr>
        <tr class="odd">
            <th> PSU</th>
            <td>{{this.tableData.PSU || 'No Data'}}</td>
        </tr>
        <tr class="even">
            <th> Segment</th>
            <td>{{this.tableData.Segment || 'No Data'}}</td>
        </tr>
        <!-- <tr
				v-if="appSettings.ACE.taskPopup.popupRows.showWave || appSettings.ACE.taskPopup.popupRows.showWave === undefined"
				> -->
				<tr class="odd">
            <th> Wave</th>
            <td>{{this.tableData.Wave || 'No Data'}}</td>
        </tr>
        </tbody>
		</table>
		<table class="popup-table" v-if="this.tag == 'address_active'">
        <tbody>
        <tr class="even">
            <th> Staff ID</th>
            <td>{{this.tableData.StaffId || 'No Data'}}</td>
        </tr>
        <tr class="odd">
            <th> Staff Name</th>
            <td>{{this.tableData.StaffName || 'No Data'}}</td>
        </tr>
        <tr class="even">
            <th> Address</th>
            <td>{{this.tableData.StreetAddress || 'No Data'}}
                <br>{{this.tableData.PlaceName || 'No Data'}}&nbsp; {{this.tableData.AdminAreaCode || 'No Data'}}&nbsp; {{this.tableData.PostCode || 'No Data'}}
            </td>
        </tr>
        <tr class="odd">
            <th> Region</th>
            <td>{{this.tableData.Region || 'No Data'}}</td>
        </tr>
        <tr class="even">
            <th> Start Date</th>
            <td>{{this.tableData.DateStart || 'No Data'}}</td>
        </tr>
        <tr class="odd" v-if="this.tableData.DateEnd">
            <th> End Date</th>
            <td>{{this.tableData.DateEnd || 'No Data'}}</td>
        </tr>
        </tbody>
    </table>
		<table class="popup-table" v-if="this.tag == 'cluster'">
        <tbody>
        <tr class="even">
            <th> Staff ID</th>
            <td>{{this.tableData.StaffId || 'No Data'}}</td>
        </tr>
        <tr class="odd">
            <th> Staff Name</th>
            <td>{{this.tableData.StaffName || 'No Data'}}</td>
        </tr>
				<!-- unsure what to do with just {{ clusterDuration }} -->
        <tr class="even" v-if="this.tableData.clusterDuration">
            <th> Duration</th>
            <td>{{this.tableData.clusterDuration || 'No Data'}}</td>
        </tr>
        <tr class="odd">
            <th> Start Time</th>
            <td>{{this.tableData.DateStart || 'No Data'}}</td>
        </tr>
        <tr class="even">
            <th> End Time</th>
            <td>{{this.tableData.DateEnd || 'No Data'}}</td>
        </tr>
        <tr class="odd">
            <th> GPS Points</th>
            <td>{{this.tableData.Points || 'No Data'}}</td>
        </tr>
        </tbody>
    </table>
		<table class="popup-table" v-if="this.tag == '12_30_3'">
        <tbody>
        <tr class="even">
            <td> Staff ID</td>
            <td>{{this.tableData.StaffId || 'No Data'}}</td>
        </tr>
        <tr class="odd">
            <td> Staff Name</td>
            <td>{{this.tableData.StaffName || 'No Data'}}</td>
        </tr>
				<!-- unsure what to do with just {{ clusterDuration }} -->
        <tr class="even" v-if="this.tableData.clusterDuration">
            <td> Duration</td>
            <td>{{this.tableData.clusterDuration || 'No Data'}}</td>
        </tr>
        <tr class="odd">
            <td> Start Time</td>
            <td>{{this.tableData.DateStart || 'No Data'}}</td>
        </tr>
        <tr class="even">
            <td> End Time</td>
            <td>{{this.tableData.DateEnd || 'No Data'}}</td>
        </tr>
        <tr class="odd">
            <td> GPS Points</td>
            <td>{{this.tableData.Points || 'No Data'}}</td>
        </tr>
        </tbody>
    </table>
	</div>
</template>

<script>
export default {
name: "PopUpTable",
props: {
	tag: String,
	tableData: Object

}
}
</script>

<style>
.popup-content {
  /* min-width: 280px;
  margin: 5px 5px;  */
}

.popup-table {
    width : -webkit-fill-available;
}

.popup-table td {
  padding: 2px 10px 2px 5px;
}

.popup-table td:not(:last-child) {
  border-right: 1px solid #d4d4d4;
}

.popup-table tr.even {
  background-color: #fff;
}

.popup-table tr.warn {
  background-color: #ffc0cb;
}

.popup-table tr.odd {
  background-color: #f3f3f3;
}

.popup-table tr:nth-child(even) {
  /* background: #f3f3f3; */
	background: rgba(21, 102, 124, 0.2);
}
.popup-table tr:nth-child(odd) {
  background: #fff;
}
.popup-table tr.alt {
  background-color: #FFCBA4;
}

.popup-table-img {
    width: 36px;
    height: 36px;
}

</style>
